module.exports = __webpack_public_path__ + "img/slide04.c9b15a45.jpg";